function hasListPosition(pageParam, positionParam) {
  return pageParam !== null && positionParam !== null;
}

function getListOffset(page, position, rowsPerPage, skipCurrentItem) {
  const base = page * rowsPerPage + position;
  return skipCurrentItem ? base + 1 : base;
}

export { hasListPosition, getListOffset };
